<template>
  <div class="company-instroduce">
    <header-common
      @popupHandle="popupHandle"
      :isFixed="isFixed"
    ></header-common>
    <div
      class="main-content"
    >
      <div class="about-us">
        <div class="text">
          <div class="chinese">关于我们</div>
          <div class="english">ABOUT US</div>
        </div>
      </div>
      <div class="instruction">
        <div class="inner">
          <div class="title">公司简介</div>
          <div class="text">
            <p class="text-item text1">南京英斯特网络科技有限公司成立于 2010 年，一直致力于面向政府及企事业客户业务和管理系统的方案设计、软件研发、大数据解决方案及相关软硬件系统的部署实施与系统集成。</p>
            <p class="text-item text2">公司拥有成熟高效的技术研发团队，在WEB、移动应用、大数据和人工智能领域都有丰富的经验和大量的技术积累。目前拥有软件算法专利3项，软件著作权几十项，是国家高新技术企业、江苏省双软企业，并通过了武器装备质量管理体系认证、IOS9001:2015质量管理体系认证、CMMI三级认证。 公司的“管理+”、“医信管家”、“精细化数据服务中心”等多个产品已经在医疗、气象、公安等行业广泛应用。</p>
              <p class="text-item" style="font-weight: 700;">公司愿景：在喧嚣的时代，给客户提供精准的信息服务。</p>
          </div>
        </div>
      </div>
      <div class="authentication">
        <div class="inner">
          <div class="title">资质认证</div>
          <ul class="logoList">
            <li class="logo-item">
              <img
                src="../../assets/images/webSite/tech_enterprises.png"
                alt=""
              >
              <p class="logoName">高新技术企业</p>
            </li>
<!--            <li class="logo-item">-->
<!--              <img-->
<!--                src="../../assets/images/webSite/intellectual_property.png"-->
<!--                alt=""-->
<!--              >-->
<!--              <p class="logoName">知识产权管理体系认证</p>-->
<!--            </li>-->
            <li class="logo-item">
              <img
                src="../../assets/images/webSite/weapon_equipment.png"
                alt=""
              >
              <p class="logoName">武器装备质量管理体系认证单位</p>
            </li>
            <li class="logo-item">
              <img
                src="../../assets/images/webSite/quality_management.png"
                alt=""
              >
              <p class="logoName">质量管理体系认证单位</p>
            </li>
            <li class="logo-item">
              <img
                src="../../assets/images/webSite/CMMIMaturity.png"
                alt=""
              >
              <p class="logoName">CMMI Maturity Level 3</p>
            </li>
            <li class="logo-item">
              <img
                src="../../assets/images/webSite/software_company.png"
                alt=""
              >
              <p class="logoName">江苏省软件企业</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="patent">
        <div class="inner">
          <div class="title">专 利</div>
          <div class="IconBox">
            <div class="icon-item">
              <img
                src="../../assets/images/webSite/patent_1.png"
                alt=""
              >
              <p class="describe">一种车辆轨迹数据聚合运算方法</p>
            </div>
            <div class="icon-item middle">
              <img
                src="../../assets/images/webSite/patent_2.png"
                alt=""
              >
              <p class="describe">一种基于地图的海量数据聚合显示方法</p>
            </div>
            <div class="icon-item">
              <img
                src="../../assets/images/webSite/patent_3.png"
                alt=""
              >
              <p class="describe">一种离散区块沿直线方向上渐变比重的确定方法</p>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="inner">
          <div class="title">著作权</div>
          <div class="certificate">
            <div
              class="minItem"
              v-for="item in certificateShow"
              :key="item.id"
            >
              <img
                :src="item.src"
                alt=""
              >
              <p class="text">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-common :isShowTopBtn="isShowTopBtn"> </footer-common>
  </div>
</template>

<script>
import headerCommon from "../common/headerCommon";
import footerCommon from "../common/footerCommon";
export default {
    name: "introduce",
    data() {
        return {
            isShowTopBtn: false,
            isFixed: false,
            certificateShow: [
                {
                    id: 1,
                    name: "信息管理系统",
                    src: require("../../assets/images/webSite/著作权/信息管理系统.png")
                },
                {
                    id: 2,
                    name: "医院信息化项目管理系统",
                    src: require("../../assets/images/webSite/著作权/医院信息化项目管理系统.png")
                },
                {
                    id: 3,
                    name: "医院信息化项目管理系统安卓APP",
                    src: require("../../assets/images/webSite/著作权/医院信息化项目管理系统安卓APP.png")
                },
                {
                    id: 4,
                    name: "癌痛护理APP软件",
                    src: require("../../assets/images/webSite/著作权/癌痛护理APP软件.png")
                },
                {
                    id: 5,
                    name: "健康档案管理",
                    src: require("../../assets/images/webSite/著作权/健康档案管理.png")
                },
                {
                    id: 6,
                    name: "健康管理系统",
                    src: require("../../assets/images/webSite/著作权/健康管理系统.png")
                },
                {
                    id: 7,
                    name: "居家肿瘤癌痛患者三级医疗护理系统",
                    src: require("../../assets/images/webSite/著作权/居家肿瘤癌痛患者三级医疗护理系统.png")
                },
                {
                    id: 8,
                    name: "门诊保健应用",
                    src: require("../../assets/images/webSite/著作权/门诊保健应用.png")
                }
            ],

            screenWidth: 1200
        };
    },
    components: {
        headerCommon,
        footerCommon
    },
    methods: {
        handleScroll() {
            let that = this;
            this.$nextTick(() => {
                // 设备/屏幕高度
                let scrollTop = document.documentElement.scrollTop; // div 到头部的距离
                if (scrollTop > 0) {
                    that.isFixed = true;
                    that.isShowTopBtn = true;
                } else {
                    that.isFixed = false;
                    that.isShowTopBtn = false;
                }
            });
        },
        popupHandle() {}
    },
    created() {},
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    }
};
</script>

<style scoped>
    .company-instroduce .main-content{
        padding-top: 60px;
    }
@media screen and (min-width: 1200px) {
  .company-instroduce .main-content .about-us {
    height: 435px;
    background: url("../../assets/images/webSite/about_us_banner.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
  }
  .company-instroduce .main-content .about-us .text {
      width: 1024px;
      height: 200px;
      margin-left: -512px;
      position: absolute;
      top: 132px;
      left: 50%;
      text-align: left;
      color: #ffffff;
  }
  .company-instroduce .main-content .about-us .text .chinese {
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: bold;
  }
  .company-instroduce .main-content .about-us .text .english {
    font-size: 16px;
  }
  .company-instroduce .main-content .instruction {
    /*height: 220px;*/
    background-color: #eef5fa;
    display: flex;
    justify-content: center;
  }
  .company-instroduce .main-content .instruction .inner {
    width: 1032px;
    height: 100%;
      padding-bottom: 10px;
  }
  .company-instroduce .main-content .title {
    padding: 30px 0 30px;
    font-size: 20px;
    font-weight: bold;
    color: #5d95df;
  }
  .company-instroduce .main-content .instruction .inner .text {
    font-size: 14px;
    color: #7e7e7e;
  }
  .company-instroduce .main-content .instruction .inner .text .text-item {
    text-indent: 20px;
    text-align: left;
    padding-bottom: 20px;
  }
  .company-instroduce .main-content .authentication {
    background-color: #fff;
    height: 405px;
    display: flex;
    justify-content: center;
  }
  .company-instroduce .main-content .authentication .inner {
    width: 876px;
    height: 100%;
  }
  .company-instroduce .main-content .authentication .inner .title {
    padding: 35px 0 22px;
  }
  .company-instroduce .main-content .authentication .inner .logoList {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .company-instroduce
    .main-content
    .authentication
    .inner
    .logoList
    .logo-item {
    font-size: 14px;
    color: #7e7e7e;
    width: 30%;
    margin-bottom: 41px;
  }
  .company-instroduce .main-content .patent {
    height: 260px;
    background-color: #eef5fa;
    display: flex;
    justify-content: center;
  }
  .company-instroduce .main-content .patent .inner {
    width: 950px;
    height: 100%;
  }
  .company-instroduce .main-content .patent .inner .IconBox {
    height: 160px;
    display: flex;
    align-items: center;
  }

  .company-instroduce .main-content .patent .inner .title {
    padding: 40px 0 10px;
  }
  .company-instroduce .main-content .patent .inner .IconBox .middle {
    margin: 0 50px 0 144px;
  }
  .main-content .patent .inner .IconBox .icon-item img {
    margin-bottom: 34px;
  }
  .main-content .patent .inner .IconBox .icon-item .describe {
    font-size: 14px;
    color: #7e7e7e;
  }
  .main-content .copyright {
    height: 545px;
    display: flex;
    justify-content: center;
    position: relative;
  }
  .main-content .copyright .dot {
    position: absolute;
    bottom: 34px;
    display: flex;
  }
  .main-content .copyright .dot .dot-item {
    width: 8px;
    height: 8px;
    background-color: #e5e5e5;
    margin-right: 10px;
    border-radius: 50%;
  }
  .selected {
    background-color: #4e97d9 !important;
  }
  .main-content .copyright .inner {
    width: 920px;
    height: 100%;
    justify-content: space-between;
  }
  .main-content .copyright .inner .title {
    padding: 35px 0 33px;
  }
  .main-content .copyright .inner .certificate {
    width: 920px;
    height: 436px;
    display: flex;
    flex-wrap: wrap;
  }
  .main-content
    .copyright
    .inner
    .certificate
    .minItem {
    width: 25%;
  }
  .main-content
    .copyright
    .inner
    .certificate
    .minItem
    img {
    width: 104px;
    height: 140px;
    margin-bottom: 15px;
  }
  .main-content
    .copyright
    .inner
    .certificate
    .minItem
    .text {
    font-size: 14px;
    color: #7e7e7e;
  }
}
@media screen and (max-width: 1199px) {
  .company-instroduce .main-content .about-us {
    height: 22.708333rem;
    background: url("../../assets/images/webSite/about_us.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding-top: 120px;
  }
  .company-instroduce .main-content .about-us .text {
    color: #fff;
    text-align: center;
  }
  .company-instroduce .main-content .about-us .text .chinese {
    margin-bottom: 15px;
    font-size: 2.5rem;
    font-weight: bold;
  }
  .company-instroduce .main-content .about-us .text .english {
    font-size: 1.25rem;
  }
  .company-instroduce .main-content .instruction {
    /* height: 375px; */
    background-color: #eef5fa;
    display: flex;
    justify-content: center;
    padding: 0 20px;
  }
  .company-instroduce .main-content .instruction .inner {
    width: 1032px;
    height: 100%;
    padding-bottom: 20px;
  }
  .company-instroduce .main-content .title {
    padding: 15px 0 15px;
    font-size: 1.145833rem;
    font-weight: bold;
    color: #5d95df;
  }
  .company-instroduce .main-content .instruction .inner .text {
    font-size: 0.833333rem;
    color: #7e7e7e;
  }
  .company-instroduce .main-content .instruction .inner .text .text-item {
    text-indent: 19px;
    text-align: justify;
    padding-bottom: 10px;
  }
  .company-instroduce .main-content .authentication {
    background-color: #fff;
    /* height: 405px; */
    display: flex;
    justify-content: center;
    padding: 0 20px;
  }
  .company-instroduce .main-content .authentication .inner {
    width: 876px;
    height: 100%;
  }
  .company-instroduce .main-content .authentication .inner .title {
    padding: 15px 0 15px;
  }
  .company-instroduce .main-content .authentication .inner .logoList {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .company-instroduce
    .main-content
    .authentication
    .inner
    .logoList
    .logo-item {
    font-size: 0.729167rem;
    color: #7e7e7e;
    width: 30%;
    margin-bottom: 30px;
  }
  .company-instroduce .main-content .patent {
    /* height: 260px; */
    background-color: #eef5fa;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 20px 30px 20px;
  }
  .company-instroduce .main-content .patent .inner {
    width: 950px;
    height: 100%;
  }
  .company-instroduce .main-content .patent .inner .IconBox {
    height: 170px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .company-instroduce .main-content .patent .inner .title {
    padding: 15px 0 15px;
  }

  .main-content .patent .inner .IconBox .icon-item {
    width: 30%;
    height: 100%;
  }
  .main-content .patent .inner .IconBox .icon-item img {
    margin-bottom: 15px;
  }
  .main-content .patent .inner .IconBox .icon-item .describe {
    font-size:.833333rem;
    color: #7e7e7e;
    word-wrap: wrap;
  }
  .main-content .copyright {
    display: flex;
    justify-content: center;
    position: relative;
  }

  .main-content .copyright .inner {
    width: 100%;
    height: 100%;
    justify-content: space-between;
  }
  .main-content .copyright .inner .title {
    padding: 15px 0 15px;
  }
  .main-content .copyright .inner .certificate {
    width: 100%;
    /* height: 436px; */
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 20px;
  }
  .main-content
    .copyright
    .inner
    .certificate
    .minItem {
    width: 33.3%;
    padding-bottom: 20px;
  }
  .main-content
    .copyright
    .inner
    .certificate
    .minItem
    img {
    width: 5.208333rem;
    height: 7.291667rem;
    margin-bottom: 10px;
  }
  .main-content
    .copyright
    .inner
    .certificate
    .minItem
    .text {
    font-size: 0.833333rem;
    color: #7e7e7e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companyIntroduce/introduce.vue